import { URN } from "@sharedcommon/model/urn.model";

export class SampleCustomerDto {
  id: string;
  urn: URN;
  distributor: string;
  batchCode: string;
  sendNumber: string;
  address: string;
  address1: string;
  postcode: string;
  city: string;
  commercialRegion: string;
  country: string;
}